import { DataSyncOkResponseSchema, PersonioCredentialsSchema } from '../../shared/data-sync';
export const testPersonioConnectionContract = {
    method: 'POST',
    path: '/api/v2/data-sync/personio/test',
    description: 'Test Personio API credentials without storing them',
    requestSchema: PersonioCredentialsSchema,
    responseSchema: DataSyncOkResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - Personio rejected the credentials',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not allowed to manage the data source',
            409: 'Conflict - Personio could not be read'
        }
    }
};

//# sourceMappingURL=test-personio-connection.contract.js.map